export function parseSlugToVariants(slug: string): string[] | null {
  const match = slug.match(/(.+)-vs-(.+)/);
  if (!match || match.length < 3) return null;

  const variants = [match[1], match[2]];
  return variants;
}

export function getMakeModelPairs(slug: string) {
  const cleanedSlug = slug.replace(/^\/|\/$/g, ""); // remove leading/trailing slashes
  const parts = cleanedSlug.split("-vs-");

  return parts.map((pair) => {
    const [make, ...modelParts] = pair.split("-");
    const model = modelParts.join(" ");
    return { make: capitalize(make), model: capitalizeWords(model) };
  });
}

function capitalize(word: string) {
  return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
}

function capitalizeWords(str: string) {
  return str.split(" ").map(capitalize).join(" ");
}

export function addModelToComparisonSlug(
  currentSlug: string,
  newModelSlug: string
): string {
  const slugParts = currentSlug.split("-vs-");

  return [...slugParts, newModelSlug].join("-vs-");
}

export function updateComparisonSlug(
  currentSlug: string,
  indexToReplace: number,
  newModelSlug: string
): string {
  const slugParts = currentSlug.split("-vs-");

  if (indexToReplace < 0 || indexToReplace >= slugParts.length) {
    console.warn("Invalid index to replace in slug");
    return currentSlug;
  }

  slugParts[indexToReplace] = newModelSlug;

  return slugParts.join("-vs-");
}

export const extractCarSlugs = (slug: string): string[] => {
  return slug.split("-vs-");
};

//TODO: remove later once Praful's changes are done

export const toSlug = (make: string, model: string): string => {
  const toSlugPart = (str: string) =>
    str
      .toLowerCase()
      .replace(/\s+/g, "-")
      .replace(/[^a-z0-9-]/g, "");

  return `${toSlugPart(make)}-${toSlugPart(model)}`;
};

// utils/parseSlugWithQuery.ts
export function parseSlugWithQuery(fullSlug: string): {
  slugPath: string;
  queryParams: Record<string, string>;
} {
  const [path, queryString] = fullSlug.split("?");
  const queryParams = new URLSearchParams(queryString || "");
  const queryObj: Record<string, string> = {};

  for (const [key, value] of queryParams.entries()) {
    queryObj[key] = value;
  }

  return {
    slugPath: path,
    queryParams: queryObj,
  };
}

export function generateVariantQueryParams(
  variants: { slug: string | undefined }[]
): string {
  return variants
    .map(
      (v, index) => `variant${index + 1}=${encodeURIComponent(v.slug ?? "")}`
    )
    .join("&");
}


export const createHeaderFromMakeModelPairs = (
  makeModelPairs: { make: string; model: string }[]
): string => {
  const carNames =
    makeModelPairs
      ?.filter((pair) => pair?.make && pair?.model) 
      ?.map((pair) => `${pair?.make} ${pair?.model}`) || [];
  return carNames.join(" vs ");
};
